var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{staticClass:"px-2 app-profile",attrs:{"dark":"","two-line":""}},[_c('v-list-item-avatar',[_c('v-img',{attrs:{"src":require("@/assets/avatar.jpg")}})],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.getUser.LastName)+" "+_vm._s(_vm.getUser.FirstName))])],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }